import styled from "styled-components";

import { Color, ColorV2, Text } from "@adoptaunabuelo/react-components";
import { Star } from "lucide-react";
import media from "styled-media-query";

const Container = styled.li`
	display: flex;
	flex: 1;
	flex-direction: column;
	border: 1px solid ${Color.line.soft};
	border-radius: 12px;
	padding: 24px;
	max-width: calc(50% - 16px);
	${media.lessThan("medium")`
		max-width: 100%;
		min-width: calc(100vw - 82px);
		padding: 20px 16px;
	`}
`;
const Row = styled.div`
	display: flex;
	flex-direction: row;
`;
const Col = styled.div`
	display: flex;
	flex-direction: column;
`;
const Image = styled.img`
	height: 48px;
	width: 48px;
	border-radius: 100px;
	background-color: ${Color.background.soft};
`;

const TestimonyCell = (props: Props) => {
	return (
		<Container>
			<Row style={{ alignItems: "center", marginBottom: 8 }}>
				<Col style={{ flex: 1 }}>
					<Text type="p" weight="medium">
						{props.testimony.name}
					</Text>
					<Row>
						<Star
							height={20}
							width={20}
							color={ColorV2.surface.secondary}
							fill={ColorV2.surface.secondary}
						/>
						<Star
							height={20}
							width={20}
							color={ColorV2.surface.secondary}
							fill={ColorV2.surface.secondary}
						/>
						<Star
							height={20}
							width={20}
							color={ColorV2.surface.secondary}
							fill={ColorV2.surface.secondary}
						/>
						<Star
							height={20}
							width={20}
							color={ColorV2.surface.secondary}
							fill={ColorV2.surface.secondary}
						/>
						<Star
							height={20}
							width={20}
							color={ColorV2.surface.secondary}
							fill={ColorV2.surface.secondary}
						/>
					</Row>
				</Col>
				<Image src={props.testimony.image} />
			</Row>
			<Text type="p2">{props.testimony.testimony}</Text>
		</Container>
	);
};
export default TestimonyCell;
export interface Props {
	testimony: {
		name: string;
		image: any;
		testimony: string;
	};
}
